module.exports = __webpack_public_path__ + "static/delivery/img/fongpai_car.9d639dd7.png";